export default __webpack_public_path__ + "static/media/ABHUB-icon.8c9f4313.svg";